import React, { useState, useEffect, createContext, useContext } from "react";
import format from "date-fns/format";
import isAfter from "date-fns/isAfter";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedOutlinedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { UserContext } from "hooks/UserContext";
import RenderPcOrMobile from "../RenderPcOrMobile";
import NotSignOutPC from "view/pc/accessQrCode/NotSignOut.pc";
import NotSignOutMobile from "view/mobile/accessQrCode/NotSignOut.mobile";
import { success } from "components/common/Constants";
import { useMsg } from "hooks/MsgProvider";
import { DATE_FORMAT_YMD, DATE_FORMAT_YMD_DISPLAY } from "constant";
import { getLeakageAttendance, submitLeakageAttendance } from "api";

export const NotSignOutViewContext = createContext({});
const hourOption = [
	{
		value: "09",
		name: "09",
	},
	{
		value: "10",
		name: "10",
	},
	{
		value: "11",
		name: "11",
	},
	{
		value: "12",
		name: "12",
	},
	{
		value: "13",
		name: "13",
	},
	{
		value: "14",
		name: "14",
	},
	{
		value: "15",
		name: "15",
	},
	{
		value: "16",
		name: "16",
	},
	{
		value: "17",
		name: "17",
	},
	{
		value: "18",
		name: "18",
	},
	{
		value: "19",
		name: "19",
	},
	{
		value: "20",
		name: "20",
	},
];

export default function NotSignOut() {
	const { user } = useContext(UserContext);
	const [open, setOpen] = useState(false);
	const { setSuccessMsg } = useMsg();
	const [hour, setHour] = useState("");
	const [minute, setMinute] = useState("");

	const [isCorrect, setIsCorrect] = useState(false);
	const [isComply, setIsComply] = useState(false);
	const [startDate, setStartDate] = useState("");

	const [id, setId] = useState(null);

	const [isError, setIsError] = useState(false);
	const [isLeavingTimeError, setIsLeavingTimeError] = useState(false);

	const renderMinuteOption = () => {
		const res = [];
		if (hour === "20") {
			res.push({ value: "00", name: "00" });
			return res;
		}
		for (let index = 0; index < 60; index++) {
			let v = index < 10 ? "0" + index : index;
			res.push({
				value: v,
				name: v,
			});
		}
		return res;
	};
	const checkIcon = (value) => {
		return value ? <CheckCircleIcon /> : <RadioButtonUncheckedOutlinedIcon style={{ color: "#999" }} />;
	};

	const getLeakage = () => {
		getLeakageAttendance()
			.then(({ data: result }) => {
				//console.log("result", result);
				const { endTime, startTime } = result || {};
				if (result && !endTime) {
					// Only show popup if startTime is before today 00:00
					const start = new Date(startTime);
					const now = new Date();
					const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());

					// Show popup if start is before today 00:00
					if (start < todayMidnight) {
						setId(result.id);
						setOpen(true);
						setStartDate(startTime);
					} else {
						setOpen(false);
					}
				} else {
					setOpen(false);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	};

	// Example:
	// If startTime is '2026-02-22T16:00:00',
	// then on '2026-02-23T00:00:00' (todayMidnight), popup will show.

	useEffect(() => {
		// console.log(user)
		if (user) {
			if (user?.roles.some((role) => role.toUpperCase().includes("RESEARCHER"))) {
				getLeakage();
			}
		}
	}, [user]);

	const submitValidate = () => {
		setIsLeavingTimeError(false);
		if (!hour || !minute || !isCorrect || !isComply) {
			setIsError(true);
			return false;
		}
		if (
			isAfter(
				new Date(startDate),
				new Date(format(new Date(startDate), "yyyy/MM/dd") + " " + hour + ":" + minute)
			)
		) {
			setIsError(false);
			setIsLeavingTimeError(true);
			return false;
		}
		return true;
	};

	const submit = () => {
		if (!submitValidate()) {
			return;
		}
		setIsError(false);
		setIsLeavingTimeError(false);
		const params = {
			id,
			leavingTime: format(new Date(startDate), DATE_FORMAT_YMD) + "T" + hour + ":" + minute,
		};
		submitLeakageAttendance(params)
			.then(({ data: result }) => {
				if (result) {
					setSuccessMsg(success.Submitted);
					getLeakage();
					setMinute("");
					setHour("");
					setIsCorrect(false);
					setIsComply(false);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const fDate = startDate && format(new Date(startDate), DATE_FORMAT_YMD_DISPLAY);

	return (
		<NotSignOutViewContext.Provider
			value={{
				open,
				minute,
				setMinute,
				hour,
				setHour,
				isCorrect,
				setIsCorrect,
				isComply,
				setIsComply,
				isError,
				isLeavingTimeError,
				renderMinuteOption,
				checkIcon,
				submit,
				fDate,
				hourOption,
			}}
		>
			<RenderPcOrMobile pc={<NotSignOutPC />} mobile={<NotSignOutMobile />} />
		</NotSignOutViewContext.Provider>
	);
}
